import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const AssetOverzichtRoute: Route = {
  path: 'customer-asset-overzicht',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/asset-overzicht.component').then((m) => m.AssetOverzichtComponent),
    },
    {
      path: 'summary',
      loadComponent: () => import('./pages/asset-overzicht.component').then((m) => m.AssetOverzichtComponent),
    },
    {
      path: 'workspace/:workspaceId/:assetId/:incidentId',
      loadComponent: () => import('./pages/asset-incident-details.component').then((m) => m.AssetIncidentDetailsComponent),
    },
    {
      // The hidden 'type' breadcrumb slot absorbs the prefix, so the crumbs read workspace > incident.
      path: 'workspace-incident/:workspaceId/:incidentId',
      loadComponent: () => import('./pages/asset-incident-details.component').then((m) => m.AssetIncidentDetailsComponent),
    },
    {
      path: ':type/:assetId/:incidentId',
      loadComponent: () => import('./pages/asset-incident-details.component').then((m) => m.AssetIncidentDetailsComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
